<template>
  <v-data-table
    :headers="headers"
    :items="compras.content"
    class="elevation-0 mt-5"
    :loading="loading"
    :server-items-length="compras.total"
    @update:options="updateOptions"
    :footer-props="footerOptions"
    no-data-text="Nenhuma compra encontrada"
    loading-text="Carregando compras..."
    :options="optionsList">
    <template v-slot:item.id="{ item }">
      <div class="text-center">
        <px-span-tooltip
            top
            :text="labelCompra(item)"
            :tooltip="tooltipCompra(item)"/>
      </div>
    </template>
    <template v-slot:item.fornecedor.nome="{ item }">
      <div v-if="item.fornecedor">
        <px-situacao-compra-icon :situacao="item.situacao"/>
        <px-span-tooltip top
                         :text="fornecedor(item)"
                         :tooltip="item.fornecedor.pessoa.nome"/>
      </div>
      <div v-else>
        <px-situacao-compra-icon :situacao="item.situacao"/>
        -
      </div>
    </template>
    <template v-slot:item.comprador="{ item }">
      <px-span-tooltip top :text="comprador(item)" :tooltip="item.comprador.pessoa.nome"/>
    </template>
    <template v-slot:item.saving="{ item }">
      {{ item.valorMoedaConvertido.saving | currency }}
      ({{ percentualSaving(item) | number('0.00') }}%)
      <div class="caption" v-if="isMoedaEstrangeiraFn(item.moeda)">
        {{ item.saving | currency(simboloMoedaFn(item.moeda),
        2,
        configuracaoFormatacaoMoedaFn(item.moeda)) }}
      </div>
    </template>
    <template v-slot:item.total="{ item }">
      {{ item.valorMoedaConvertido.total | currency }}
      <px-moeda-chip v-if="isMoedaEstrangeiraFn(item.moeda)" :moeda="item.moeda"/>
      <div class="caption" v-if="isMoedaEstrangeiraFn(item.moeda)">
        {{ item.total | currency(simboloMoedaFn(item.moeda),
        2,
        configuracaoFormatacaoMoedaFn(item.moeda)) }}
      </div>
    </template>
    <template v-slot:item.options="{ item }">
      <div class="text-right">
        <v-btn v-if="!isRascunho(item)"
               icon
               @click="goToCompra(item)">
          <v-icon>mdi-eye</v-icon>
        </v-btn>
      </div>
    </template>
  </v-data-table>
</template>

<script>
import Vue from 'vue';
import currency from 'currency.js';
import { SituacaoCompra } from 'px-business-components';
import moedaMixin from '@/mixins/moeda-mixin';

export default {
  mixins: [moedaMixin],
  props: {
    compras: Object,
    default: [],
    loading: Boolean,
    onChangeOptions: {
      type: Function,
      required: true,
    },
    optionsList: Object,
  },
  data() {
    return {
      expanded: [],
      footerOptions: {
        itemsPerPageOptions: [5, 10, 15, 20],
        itemsPerPageText: 'Linhas por página',
      },
      headers: [
        {
          text: 'Código',
          sortable: false,
          value: 'id',
        },
        {
          text: 'Fornecedor',
          value: 'fornecedor.nome',
        },
        {
          text: 'Empresa',
          value: 'comprador',
        },
        {
          text: 'Saving',
          value: 'saving',
        },
        {
          text: 'Total',
          value: 'total',
        },
        {
          text: null,
          sortable: false,
          value: 'options',
        },
      ],
    };
  },
  computed: {
    percentualSaving() {
      return (item) => {
        if (!item.saving) {
          return 0;
        }
        return currency(item.saving).multiply(100)
          .divide(currency(item.total).add(item.saving))
          .value;
      };
    },
    labelCompra() {
      return compra => (compra.codigoInterno ? `${compra.codigoInterno} / ${compra.id}` : compra.id);
    },
    tooltipCompra() {
      return compra => (compra.codigoInterno ? 'Pedido de OC gerada / Pedido Proxpect' : 'Pedido Proxpect');
    },
    comprador() {
      return item => Vue.filter('truncate')(item.comprador.pessoa.nome, 30);
    },
    fornecedor() {
      return item => Vue.filter('truncate')(item.fornecedor.pessoa.nome, 30);
    },
    isRascunho() {
      return item => SituacaoCompra.keys.RASCUNHO.key === item.situacao;
    },
  },
  methods: {
    updateOptions(options) {
      this.onChangeOptions(options);
    },
    goToCompra(item) {
      this.$router.push({
        name: 'main.compras.detalhes',
        params: {
          id: item.id,
        },
        query: {
          backLink: '/indicadores-compras#lista-compras',
        },
      });
    },
  },
};
</script>
